import type { ReactNode } from 'react';

export interface SectionTabItem {
  id: string;
  label: string;
  badge?: ReactNode;
}

interface SectionTabsProps {
  items: SectionTabItem[];
  activeId: string;
  onChange: (id: string) => void;
  sticky?: boolean;
}

export default function SectionTabs({
  items,
  activeId,
  onChange,
  sticky = false,
}: SectionTabsProps) {
  return (
    <div className={sticky ? 'acc-section-tabs acc-section-tabs--sticky' : 'acc-section-tabs'}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={
            item.id === activeId
              ? 'acc-section-tabs__button acc-section-tabs__button--active'
              : 'acc-section-tabs__button'
          }
          onClick={() => onChange(item.id)}
        >
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <span>{item.label}</span>
            {item.badge ? <span className="acc-section-tabs__badge">{item.badge}</span> : null}
          </span>
        </button>
      ))}
    </div>
  );
}
